<script setup lang="ts">
import {onMounted, onUnmounted, ref, Ref, watch} from 'vue';
import {ElProgress} from 'element-plus';
import {type Voortgang} from '@/base/uploadMetVoortgang.js';

const props = defineProps<{
    voortgang?: Voortgang;
}>();

const verstreken: Ref<number> = ref(0);
let timer: ReturnType<typeof setInterval> | undefined;

// a new run (voortgang goes from unset to set) restarts the counter
watch(() => props.voortgang, (nieuw, vorige) => {
    if (nieuw && !vorige) {
        verstreken.value = 0;
    }
});

onMounted(() => {
    timer = setInterval(() => {
        if (props.voortgang) {
            verstreken.value += 1;
        }
    }, 1000);
});

onUnmounted(() => {
    clearInterval(timer);
});
</script>

<template>
    <div v-if="voortgang" class="w-full">
        <el-progress
            :percentage="voortgang.percentage ?? 100"
            :indeterminate="voortgang.percentage === undefined"
            :duration="3"
            :show-text="false"
        />
        <div class="text-sm text-gray-500">{{ voortgang.tekst }} ({{ verstreken }}s)</div>
    </div>
</template>
